<div class="row narrow-gutters">
  <div class="col-md-auto">
    <app-search [(ngModel)]="declaration" [searchFunction]="searchMessages" [resultFormatter]="formatDeclaration"
                [inputFormatter]="formatDeclaration"
                (ngModelChange)="openMessages(declaration)" [placeholder]="'Search message'">
    </app-search>
  </div>
  <div class="col-md-auto ms-auto">
    <span class="dropdown mx-1 always-enabled">
      <button class="btn btn-outline-secondary dropdown-toggle" style="min-width: 7rem" type="button"
              data-bs-toggle="dropdown">Outgoing
        <span class="caret"></span></button>
        <ul class="dropdown-menu dropdown-menu-end">
          @for (manifest of manifests; track manifest) {
            @for (declaration of getFirstDeclarations(manifest); track declaration) {
              @if (declaration.type === 'SDT' || declaration.type === 'ENS') {
                <li (click)="openMessages(declaration)"
                    class="dropdown-item">{{ declaration.type }} of {{ declaration.id }} to Singlewindow</li>
              }
            }
          }
        </ul>
      </span>
    @if (rejectAllowed()) {
      <button data-bs-toggle="modal" data-bs-target="#rejectImportModal" type="button"
              class="btn-sm btn btn-outline-danger mx-1 py-1" style="min-width: 7rem" tabindex="-1">Reject SDT
      </button>
    }
    @if (acceptAllowed()) {
      <button (click)="accept()" type="button" class="btn-sm btn btn-outline-success mx-1"
              style="min-width: 7rem" tabindex="-1">Accept SDT
      </button>
    }
  </div>
</div>

<div id="rejectImportModal" class="modal fade" data-bs-backdrop="false" tabindex="-1" role="dialog">
  <div class="modal-dialog shadow" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title">Reject reason</h5>
      </div>
      <div class="modal-body">
        <input id="rejectImport-reason" type="text" class="form-control">
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Back</button>
        <button type="button" class="btn btn-primary" data-bs-dismiss="modal"
                (click)="reject(appContext.getDocument().getElementById('rejectImport-reason')['value'])">Reject SDT
        </button>
      </div>
    </div>
  </div>
</div>

